import { pushToGTM } from "@lib/gtmUtility"

const eventObj = {
    category: "Footer",
    eventName: "newGAEvent",
}

const addEvent = ({ label, action, eventName, category }) => {
    eventObj.label = label
    eventObj.action = action
    if (category) eventObj.category = category
    if (eventName) eventObj.eventName = eventName
    pushToGTM(eventObj, eventName)
}

export default {
    onClick: (label, action) => {
        addEvent({ label, action })
    },
    onDownloadAppLink: (label) => {
        addEvent({ label, action: "Download App" })
    },
}
